export const DISTRITAL_DIRECTOR_ROLE = 3;


// WEBPACK FOOTER //
// ./src/app/config/data.ts